import Swal from 'sweetalert2'
// import merge from 'lodash/merge'

const baseConfig = {
  title: 'Are you sure?',
  text: false,
  showCancelButton: true,
  cancelButtonText: 'Cancel',
  confirmButtonText: 'Yes',
  buttonsStyling: false,
  customClass: {
    confirmButton: 'bg-green-500 text-white mr-4',
    cancelButton: 'bg-gray-200 text-gray-800'
  }
}

export default {

  confirm (config: any) {
    const params = {...baseConfig, ...config}
    return Swal.fire(params)
  }

}